import './Accordion.scss';
import Control from "../../Control";
import AccordionItem from "./AccordionItem";
import Delegate from "../../Delegate";

export default class Accordion extends Control {
	public EvScrolled: Delegate;
	private _Items: AccordionItem[];
	public EvItemOpening: Delegate;
	private _SelectedItem: AccordionItem;
	private _FullHeight: boolean;
	private _AutoCollapse: boolean;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._Items = [];
		this.EvScrolled = new Delegate();
		this.EvItemOpening = new Delegate();
		this._FullHeight = false;
		this._AutoCollapse = true;
		super._initFields(settings);
		this._Items = this._Items.filter(item => !!item);
	}

	getItems()
	{
		return this._Items;
	}

	_render()
	{
		this.np_render("<div class='accordion app-list'></div>", true);

		if (this._FullHeight)
			this.addClass('accordion--full-height');

		this.setItems(this._Items);

		this.addEvent(this._root, 'scroll', () =>
		{
			this.EvScrolled.fire(this, {
				scroll: this._root.scrollTop
			});
		});
	}

	setItems(value: AccordionItem[] | object)
	{
		this._Items = value as AccordionItem[];
		if (this._Items)
			this._Items.forEach((item: any, index: number) =>
			{
				item.ParentNode = this._root;
				item.EvHeaderClick = this._onHeaderItemClick.bind(this);
				if (!item.Value)
					item.Value = index;
				this._Items[index] = new AccordionItem(item);
			});
	}

	_onHeaderItemClick(item: AccordionItem)
	{
		if (!this._AutoCollapse)
		{
			item.toggle()
			return;
		}

		if (item == this._SelectedItem)
		{
			this._SelectedItem.collapse();
			this._SelectedItem = null;
		}
		else
		{
			let args = {Item: item, Cancel: false};
			this.EvItemOpening.fire(this, args);
			if (!args.Cancel)
				this.showItem(item.getValue());
		}
	}

	getItemByPropValue(propName: string, value: any)
	{
		for (let item of this.getItems())
		{
			if ((<any>item)["get" + propName]() == value)
				return item;
		}
	}

	getItem(value: any)
	{
		return this.getItemByPropValue('Value', value);
	}

	getSelectedItem()
	{
		return this._SelectedItem;
	}

	showItem(value: any)
	{
		let item = this.getItem(value);
		if (this._AutoCollapse)
			if (this._SelectedItem && this._SelectedItem != item)
				this._SelectedItem.collapse();
		if (item)
			item.open();

		this._SelectedItem = item;
	}

	openFirstIfNeed()
	{
		if (!this._SelectedItem)
		{
			let item = this._Items.find(item => item.getIsVisible());
			if (item)
			{
				item.open(false);
				this._SelectedItem = item;
			}
		}
	}

	sortHiddenItems()
	{
		let visibleItems = this._root.querySelectorAll('.accordion__item:not(.hide)');

		if (visibleItems && visibleItems.length > 0)
		{
			let lastVisibleItem = visibleItems[visibleItems.length - 1];
			this._root.childNodes.forEach((item: HTMLElement) =>
			{
				if (item.className.indexOf('hide') != -1)
					this._root.insertBefore(item, lastVisibleItem);
			});
		}
	}
}